// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__wDXNJ","label":"Completed_label__3yGt5"};